import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

/**
 * Admin ToDo aggregator — fans out across expense/time-report/tax-report
 * contributors on the backend and returns one flat response:
 *
 *   { groups: TodoGroup[], errors: [{contributor, message}], generatedAt, totalCount }
 *
 * Non-admins get 403 (backend-gated). Caller should treat 403 as "no todos".
 */
export const fetchTodos = (companyId) =>
  axios.get(getApiUrl(`${companyId}/dashboard/todos`), { withCredentials: true });
